import {
  Badge,
  CommentSquare1StIcon,
  Flex,
  MapPinIcon,
  SparklesIcon,
  ListTreeIcon,
  Tooltip,
  VisuallyHidden,
} from '@buffer-mono/popcorn'

import {
  useMetadataFirstComment,
  useMetadataGeolocation,
  useMetadataIsAiGenerated,
  useMetadataThread,
  useMetadataThreadCount,
  usePostData,
} from '~publish/components/PostCard/PostCardContext'

import styles from './PostCardAddons.module.css'

import type { JSX } from 'react'

export const PostCardAddons = (): JSX.Element | null => {
  const { metadata } = usePostData()

  const threadCount = useMetadataThreadCount(metadata)
  const thread = useMetadataThread(metadata)
  const firstComment = useMetadataFirstComment(metadata)
  const geolocation = useMetadataGeolocation(metadata)
  const isAiGenerated = useMetadataIsAiGenerated(metadata)

  return (
    <Flex direction="row" gap="xs">
      {threadCount > 1 && (
        <Tooltip
          content={
            <span
              className={styles.tooltip}
            >{`Thread (${threadCount} posts) ${thread?.[1]?.text}`}</span>
          }
        >
          <Flex data-testid="addon-icons-x" gap="2xs">
            <ListTreeIcon />
            <Badge size="small">
              {threadCount}
              <VisuallyHidden>thread posts</VisuallyHidden>
            </Badge>
          </Flex>
        </Tooltip>
      )}
      {firstComment && (
        <Tooltip content={`First comment: ${firstComment}`}>
          <CommentSquare1StIcon
            data-testid="first-comment-icon"
            aria-label={`First comment: ${firstComment}`}
          />
        </Tooltip>
      )}
      {geolocation && (
        <Tooltip content={`Location: ${geolocation?.text}`}>
          <MapPinIcon
            data-testid="map-icon"
            aria-label={`Location: ${geolocation?.text}`}
          />
        </Tooltip>
      )}
      {isAiGenerated && (
        <Tooltip content="Flagged as AI-generated content">
          <SparklesIcon
            data-testid="ai-generated-icon"
            aria-label="AI-generated content"
          />
        </Tooltip>
      )}
    </Flex>
  )
}
